export default __webpack_public_path__ + "static/media/chest.779494dd.mp3";